export default function isOdd(value) {
    return value % 2 !== 0;
}
